import { DateTime } from "luxon";
import { useEffect, useState } from "react"

export default function Admin() {

    const [displayHours, setDisplayHours] = useState([]);

    useEffect(() => {
        
        
    const now = DateTime.local()
    const prev2Hours = now.minus({hour: 1}).startOf('hour')
    const prevHour = prev2Hours.plus({hour: 1}).startOf('hour')
    const nextHour = prev2Hours.plus({hour: 2}).startOf('hour')
    setDisplayHours([prev2Hours, prevHour, nextHour])


    setTimeout(() => {
        
      setInterval(() => {
        const now = DateTime.local()
        if ([0, 30].includes(now.minute)) {

              // console.log('updating time');
              const prev2Hours = now.minus({hour: 1}).startOf('hour')
              const prevHour = prev2Hours.plus({hour: 1}).startOf('hour')
              const nextHour = prev2Hours.plus({hour: 2}).startOf('hour')
              setDisplayHours([prev2Hours, prevHour, nextHour])        
        }
      }, 60000);
    }, now.startOf('minute').plus({minute: 1}).valueOf() - now.valueOf() );

    


    }, []);

    return (<>{displayHours.map(hour => hour.toFormat("HH:mm"))}</>)
}